<template>

    <div class='sort-container'>
        <div class='sort-by-text'>Sort by:</div>
        <div class='selected-sort' @click='toggleShowSortMenu'>
            <span id='selected_sort_text' >{{selected_sort.text}}</span>
            <span id='selected_sort_icon' class="fa-solid fa-chevron-down sort-icon"></span>
        </div>
        <div class='sort-dropdown' id='list_sort_dropdown_menu' v-if='show_sort_menu'>
            <div v-for='option in sorting_options' :key='option.id'>
                <div v-show='option.show' class='option' @click='selectSortOption(option)'>{{option.text}}</div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: ['show_recommended_sort', 'default_sort'],
    emits:['sortListener'],
    data(){
        return{
            sort_by: 'product.keyword_asc',
            sorting_options: [
                {id: 1, value: 'price_desc', text: 'Price (Highest - Lowest)', default: false, show: true},
                {id: 2, value: 'price_asc', text: 'Price (Lowest - Highest)', default: false, show: true},
                {id: 3, value: 'product.keyword_asc', text: 'Alphabetically (A-Z)', default: false, show: true},
                {id: 4, value: 'product.keyword_desc', text: 'Alphabetically (Z-A)', default: false, show: true},
                {id: 5, value: 'recommended', text: 'Recommended', default: false, show: false},
            ],
            selected_sort: {},
            show_sort_menu: false
        }
    },
    methods:{
        sortResults(){
            let split_sort = this.selected_sort.value.split('_');
            let sort_column = split_sort[0];
            let sort_order = split_sort[1];
            this.$emit('sortListener', sort_column, sort_order);
        },
        selectSortOption(option){
            this.selected_sort = option;
            this.sortResults();
            this.toggleShowSortMenu();
        },
        toggleShowSortMenu(){
            this.show_sort_menu = !this.show_sort_menu;
        },
        listenForClickOutsideSortMenu(){
            let self = this;

            document.addEventListener('click', function checkSortMenuListClick(e) {
                let sort_dropdown = document.getElementById('list_sort_dropdown_menu');
                if(sort_dropdown != null){
                    if(self.show_sort_menu == true && !sort_dropdown.contains(e.target) && e.target.id != 'selected_sort_text'  && e.target.id != 'selected_sort_icon'){
                        self.show_sort_menu = false;
                    }
                }
            });
        }
    },
    mounted(){
        this.listenForClickOutsideSortMenu();

        const urlParams = new URLSearchParams(window.location.search);
        let search_string = urlParams.get('q') ?? '';
        if(search_string != ''){
               this.sorting_options.filter(x=>x.value == 'recommended')[0].default = true;
               this.sorting_options.filter(x=>x.value == 'recommended')[0].show = true;
        }   
        else{
            this.sorting_options.filter(x=>x.value == 'product.keyword_asc')[0].default = true;
            this.sorting_options.filter(x=>x.value == 'product.keyword_asc')[0].default = true;
        }

        this.selected_sort = this.sorting_options.filter(x=>x.default == true)[0];
    },
    watch:{
        'default_sort': function(){
             if(this.search_string == ''){
                let sort = `${this.default_sort.column}_${this.default_sort.order}`;
                this.sorting_options.filter(x=>x.default == true)[0].default = false;
                this.sorting_options.filter(x=>x.value == sort)[0].default = true;

                this.selected_sort = this.sorting_options.filter(x=>x.default == true)[0];
             }
        }
    }
}
</script>

<style lang="scss" scoped>
.sort-container{
    display:flex;
    align-items: center;
    gap: 10px;
    position: relative;
}

.sort-by-text{
    opacity: 0.8;
}

.selected-sort{
    cursor: pointer;
}

.sort-icon{
    margin-left: 5px;
}

.sort-dropdown{
    width: 220px;
    height: auto;
    background-color: white;
    position: absolute;
    right: 0;
    top: 35px;
    box-sizing: border-box;
    z-index: 1;
    border: solid #dee2e6 1px;
}

.option{
    cursor: pointer;
    padding: 10px 20px;
}

.option:hover{
    background-color: #E4E0E1;
}

</style>